let CoverArt = require('./CoverArt');

module.exports = class Covers {
    constructor() {
        /** @type {CoverArt} */ this.cover150Wide = null;
        /** @type {CoverArt} */ this.cover300Wide = null;
        /** @type {CoverArt} */ this.cover510Wide = null;
    }
};
